module.exports = __webpack_public_path__ + "static/media/f3.66359d61.png";